import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setIsAdmin } = useAuth() || {};
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (setUser) setUser(data.user);
        if (setIsAdmin) setIsAdmin(!!data.is_admin);
        // Clear hash and route to admin
        window.history.replaceState(null, "", "/admin");
        navigate(data.is_admin ? "/admin" : "/admin/login", { replace: true, state: { user: data.user, error: data.is_admin ? null : "Not authorized" } });
      } catch (e) {
        navigate("/admin/login", { replace: true, state: { error: "Sign-in failed. Please try again." } });
      }
    })();
  }, [navigate, setUser, setIsAdmin]);

  return (
    <div className="min-h-screen grid place-items-center bg-white">
      <div className="text-slate-500 text-sm">Signing you in…</div>
    </div>
  );
}
